query landingpageSlugsUsedForInvitation {
  invitedLandingpageSlugs: landingpageSlugsUsedForInvitation
}
